import { NgModule } from '@angular/core';
import { ErrorBoxComponent } from './components/error-box/error-box.component';
import { CommonModule } from '@angular/common';
import { PageHeaderTitleComponent } from './components/page-header-title/page-header-title.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TableFooterComponent } from './components/table-footer/table-footer.component';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { ToastNotificationComponent } from './components/toast-notification/toast-notification.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { EntityBrowserComponent } from './components/entity-browser/entity-browser.component';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { DirectivesModule } from '../directives/directives.module';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { SingleAttachmentBrowserComponent } from './components/single-attachment-browser/single-attachment-browser.component';
import { MatChipsModule } from '@angular/material/chips';
import { ColumnTextComponent } from './components/table-columns/column-text/column-text.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColumnCompanyComponent } from './components/table-columns/column-company/column-company.component';
import { ColumnSelectComponent } from './components/table-columns/column-select/column-select.component';
import { TableColumnComponent } from './components/table-columns/table-column/table-column.component';
import { ColumnCheckboxComponent } from './components/table-columns/column-checkbox/column-checkbox.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ColumnDateComponent } from './components/table-columns/column-date/column-date.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MomentModule } from 'ngx-moment';
import { PipesModule } from '../pipes/pipes.module';
import { ColumnIconComponent } from './components/table-columns/column-icon/column-icon.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCardModule } from '@angular/material/card';
import { ColumnSwitchComponent } from './components/table-columns/column-switch/column-switch.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ColumnProgressComponent } from './components/table-columns/column-progress/column-progress.component';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@NgModule({
    declarations: [
        ErrorBoxComponent,
        PageHeaderTitleComponent,
        TableFooterComponent,
        ToastNotificationComponent,
        EmptyStateComponent,
        EntityBrowserComponent,
        ConfirmDialogComponent,
        SingleAttachmentBrowserComponent,
        TableColumnComponent,
        ColumnCheckboxComponent,
        ColumnCompanyComponent,
        ColumnTextComponent,
        ColumnSelectComponent,
        ColumnDateComponent,
        ColumnIconComponent,
        ColumnSwitchComponent,
        ColumnProgressComponent,
    ],
    exports: [
        ErrorBoxComponent,
        PageHeaderTitleComponent,
        TableFooterComponent,
        ToastNotificationComponent,
        EmptyStateComponent,
        EntityBrowserComponent,
        ConfirmDialogComponent,
        SingleAttachmentBrowserComponent,
        TableColumnComponent,
        ColumnCheckboxComponent,
        ColumnCompanyComponent,
        ColumnTextComponent,
        ColumnSelectComponent,
        ColumnDateComponent,
        ColumnIconComponent,
        ColumnSwitchComponent,
        ColumnProgressComponent,
    ],
    imports: [
        CommonModule,
        DirectivesModule,
        MatIconModule,
        MatButtonModule,
        MatSelectModule,
        MatDividerModule,
        MatDialogModule,
        MatChipsModule,
        MatTableModule,
        MatSortModule,
        MatInputModule,
        MatTooltipModule,
        FormsModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MomentModule,
        PipesModule,
        DragDropModule,
        MatCardModule,
        MatSlideToggleModule,
        MatExpansionModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        CdkVirtualScrollViewport,
    ],
    providers: [
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: {
                ...new MatDialogConfig(),
                width: 480,
                autoFocus: false,
            },
        },
    ],
})
export class ComponentsModule {}
